<template>
  <div class="home">
    <view-layout
      :header="header[language]"
    >
      <h2>{{ homeLanguageElements.name }}</h2>
      <div class="home-container">
        <div class="home-text">
          👨‍💻 {{ homeLanguageElements.studying }}
        </div>
        <div class="home-text">
          ⚙️ {{ homeLanguageElements.interest }}
        </div>
        <div class="home-text">
          🎡 {{ homeLanguageElements.hobbies }}
        </div>
        <div class="home-text">
          🎯 {{ homeLanguageElements.purpose }}
        </div>
      </div>
    </view-layout>
  </div>
</template>

<script>
import {mapGetters, mapState} from "vuex";

import ViewLayout from "../components/ViewLayout";

export default {
  name: 'Home',
  computed: {
    ...mapGetters([
        "homeLanguageElements"
    ]),
    ...mapState([
      "language"
    ])
  },
  components: {
    ViewLayout
  },
  data() {
    return {
      header: {
        "En": "Hello, friend!",
        "Ru": "Привет, друг!"
      }
    }
  }
}
</script>

<style scoped>
h2 {
  font-size: 36px;
  margin-bottom: 10px;
  text-align: center;
}

.home-container {
  margin-top: 60px;
}

.home-text {
  font-size: 18px;
  width: 400px;
  margin: 0 auto 10px auto;
}

@media only screen and (max-width : 500px) {
  .home-text {
    width: 100%;
  }
}
</style>